export default {
    name: "progress-ring",
    data() {
        const normalizedRadius = this.radius - 2;
        const circumference = normalizedRadius * 2 * Math.PI;
        return {
            normalizedRadius,
            circumference
        };
    },
    props: {
        radius: {
            type: Number,
            default: 0
        },
        progress: {
            type: Number,
            default: 50
        },
        stroke: {
            type: Number,
            default: 10
        },
        color: {
            type: String,
            default: 'black'
        },
        digits: {
            type: Boolean,
            default: true
        },
        max: {
            type: Number,
            default: 100
        }
    },
    methods: {},
    computed: {
        strokeDashoffset() {
            return this.circumference - this.progress / 100 * this.circumference;
        }
    }
}
